import Storage from '@aws-amplify/storage';
import S3Helper from '@/utils/s3-helper';

export async function getSignedS3Url({ bucket, region, key }) {
  return Storage.get(key, {
    bucket,
    region,
    // Amplify tries to add /public to all urls, this tells it not to
    customPrefix: {
      public: '',
    },
  });
}

/**
 * This function can be used for signing s3 urls
 *
 * @param {string} maybeUnsignedUrl a url string that may or may not be unsigned
 */
export async function signS3Url(maybeUnsignedUrl) {
  const { bucket, region, key } = S3Helper.parseUrl(maybeUnsignedUrl);
  // If we successfully parse URL for s3 url params then we should sign
  if (bucket && region && key) {
    return getSignedS3Url({ bucket, region, key });
  }
  // unable to parse url for s3 params, most likely doesn't require signing
  return maybeUnsignedUrl;
}
